import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
import { Link as RouterLink } from "react-router-dom";
import { createGlobalStyle } from "styled-components";

// Components
import Sidebar from "../Nav/Sidebar";
import Backdrop from "../Elements/Backdrop";
// Assets
import LogoIcon from "../../assets/svg/Logo";
import BurgerIcon from "../../assets/svg/BurgerIcon";
// Menu data
import menuData from "../../data/menuData";
import { useNavigate, useLocation } from "react-router-dom";

export default function TopNavbar() {
  const [y, setY] = useState(window.scrollY);
  const [sidebarOpen, toggleSidebar] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const GlobalStyle = createGlobalStyle`
  * {
    font-family: 'Poppins', sans-serif;
  }
`;

  useEffect(() => {
    const handleScroll = () => setY(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const servicesMenu = menuData.find((item) => item.title === "Services");
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id) => {
    if (location.pathname === "/") {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/", { state: { scrollTo: id } });
    }
  };

  return (
    <>
      <GlobalStyle />

      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      {sidebarOpen && <Backdrop toggleSidebar={toggleSidebar} />}
      <Wrapper
        className="flexCenter animate whiteBg"
        style={y > 100 ? { height: "60px" } : { height: "80px" }}
      >
        <NavInner className="container flexSpaceCenter">
          <Link
            className="pointer flexNullCenter"
            to="home"
            smooth={true}
            style={{ height: "100%", display: "flex", alignItems: "center" }}
          >
            <LogoIcon width="100%" height="100%" />
            {/* <h1 style={{ marginLeft: "15px", fontSize: "20px", fontWeight: "800" }}>
              SRR-Intech
            </h1> */}
          </Link>

          <BurderWrapper
            className="pointer"
            onClick={() => toggleSidebar(!sidebarOpen)}
          >
            <BurgerIcon />
          </BurderWrapper>

          <UlWrapperRight className="flexNullCenter">
          <UlWrapper className="flexNullCenter">
            <div
              className="semiBold font15 pointer flexCenter"
              style={{ fontSize: "18px", marginRight: "25px" }}
            >
                  <li className="semiBold font15 pointer" style={{ fontSize: "18px" }}>
              <Link activeClass="active" onClick={() => 
      scrollToSection("home") // your custom handler
    } style={{ padding: "10px 15px" }} to="home" spy={true} smooth={true} offset={-80}>
                Home
              </Link>
            </li>

            </div>
            <li className="semiBold font15 pointer" style={{ fontSize: "18px" }}>

<DropdownLi
  className="semiBold font15 pointer" 
  style={{ fontSize: "18px" }}
>
  <div
    className="inline-flex items-center gap-1"
   
    style={{ padding: "10px 10px", cursor: "pointer" }}
    onClick={() => setShowDropdown(!showDropdown)}
  >
    Services
    <span>
      <svg
        className="text-gray-400"
        viewBox="0 0 20 20"
        fill="currentColor"
        aria-hidden="true"
        data-slot="icon"
        style={{
          width: "20px",
          height: "20px",
          transform: "translateY(5px)", // Slight nudge down
        }}
      >
        <path
          fillRule="evenodd"
          d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
          clipRule="evenodd"
        />
      </svg>
    </span>
  </div>

  {showDropdown && (
    <DropdownMenu
      className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-hidden"
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="menu-button"
    >
      <div className="py-1"  style={dropdownMenuStyle}>
        {servicesMenu?.submenu?.map((sub) => (
          <RouterLink
            key={sub.id}
            to={sub.path}
            className="block px-4 py-2 text-sm text-gray-700"
            style={dropdownItemStyle}
            
          >
            {sub.title}
          </RouterLink>
        ))}
      </div>
    </DropdownMenu>
  )}
</DropdownLi>
</li>
            <div
              className="semiBold font15 pointer flexCenter"
              style={{ fontSize: "18px", marginRight: "25px" }}
            >
                   <li className="semiBold font15 pointer" style={{ fontSize: "18px" }}>
              <Link
                activeClass="active"
                onClick={() => scrollToSection("about")}
                style={{ padding: "10px 15px" }}
                to="about"
                spy={true}
                smooth={true}
                offset={-80}
              >
                About
              </Link>
            </li>
            
            </div>
           
            {/* <li className="semiBold font15 pointer" style={{ fontSize: "18px" }}>
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="careers" spy={true} smooth={true} offset={-80}>
                Careers
              </Link>
            </li> */}
          </UlWrapper>

          <li className="semiBold font15 pointer" style={{ fontSize: "18px" }}>
              <Link
                activeClass="active"
                onClick={() => scrollToSection("contact")}
                style={{ padding: "10px 15px" }}
                to="contact"
                spy={true}
                smooth={true}
                offset={-80}
              >
                Contact
              </Link>
            </li>
      
            <li className="semiBold font15 pointer flexCenter" 

              style={{ fontSize: "18px", marginLeft: "25px" }}
              onClick={() => scrollToSection("login")}
            >
              <button style={{ backgroundColor: "#7620ff", color: "white", padding: "10px 40px", border: "none", borderRadius: "5px", fontSize: "16px", cursor: "pointer", textAlign: "center", }} >
                <a href="https://app.srrintech.com" style={{ color: "white" }}>Login</a>
              </button>
            </li>


          </UlWrapperRight>
        </NavInner>
      </Wrapper>
    </>
  );
}
// Inline style for grid layout (4 columns)
const dropdownMenuStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(5, 1fr)", // 4 columns per row
  gap: "20px", // Space between grid items
  padding: "10px",
  backgroundColor: "white",
  zIndex: "1000",
};

// DropdownItem style for each link in the dropdown
const dropdownItemStyle = {
  textDecoration: "none",
  display: "block",
  whiteSpace: "nowrap",
  fontSize: "15px",
};
const Wrapper = styled.nav`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
`;
const NavInner = styled.div`
  position: relative;
  height: 100%;
`;
const BurderWrapper = styled.button`
  outline: none;
  border: 0px;
  background-color: transparent;
  height: 100%;
  padding: 0 15px;
  display: none;
  @media (max-width: 760px) {
    display: block;
  }
`;
const UlWrapper = styled.ul`
  display: flex;
  gap: 10px;
  @media (max-width: 760px) {
    display: none;
  }
`;
const UlWrapperRight = styled.ul`
  @media (max-width: 760px) {
    display: none;
  }
`;

const DropdownLi = styled.li`
  position: relative;
  padding: 10px 10px 10px 10px;
  &:hover > div {
    display: inline;
  }
`;

const DropdownMenu = styled.div`
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  flex-direction: row;
  flex-wrap: wrap;
  background: white;
  border: 1px solid #eaeaea;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 500px;
  padding: 10px;
  gap: 10px;
`;
